<template>
  <custom-popover class="template-data-popover" :backdrop="true" @close="$emit('close')">
    <div class="popover-header">
      <div class="left-side-header">
        <h2>{{ $t("tp-data-popover.header") }}</h2>
        <span class="small">- {{ $t("tp-data-popover.small") }}</span>
      </div>

      <div class="close-popover" @click.stop.prevent="onClose()">
        <i class="fa-light fa-times"></i>
      </div>
    </div>
    <div class="d-flex">
      <div class="popover-step data-selector">
        <div class="search-filter">
          <!-- <input ref="searchinput" class="search-input" :placeholder="searchPlaceholder" v-model.trim="filter" @input="onFilterChange(filter)" /> -->
          <custom-input
            ref="searchinput"
            @input="onFilterChange(filter)"
            class="search-input"
            v-model.trim="filter"
            :inputType="'text'"
            :name="'dataSearchInput'"
            :label="searchPlaceholder"
            :placeholder="$t('search')"
            :autoComplete="'off'"
            :focusInputField="true"
          />
          <div @click="onEraseFilter(filter)" v-if="eraser" class="erase-wrapper">
            <i class="close-icon fa-light fa-times"></i>
          </div>
          <div v-show="searching">
            <i class="searching fa-light fa-circle-notch fa-spin"></i>
          </div>
          <div v-show="!searching" class="search-icon">
            <i class="fa-light fa-search"></i>
          </div>
        </div>

        <div class="result-list custom-scrollbar-light">
          <div class="result-item" @click="onSelectResult(null)" :class="{ 'is-selected': !selectedDatasetId }">
            <div class="flex-grow-1">
              <div>{{ $t("tp-data-popover.sample") }}</div>
              <div class="text-muted">{{ $t("tp-data-popover.data-fill") }}</div>
            </div>
            <i class="fa-light fa-chevron-right"></i>
          </div>
          <div
            v-for="result in resultList"
            :key="result.referenceName"
            :class="{ 'is-selected': result.id === selectedDatasetId }"
            class="result-item"
            :title="result.referenceName"
            @click="onSelectResult(result)"
          >
            <div class="flex-grow-1">
              <div>{{ result.referenceName }}</div>
              <div class="text-muted" v-if="result.time">{{ new Date(result.time) | dateFormat("DD.MM.YYYY") }}</div>
              <div class="text-muted" v-else>{{ result.id }}</div>
            </div>
            <div class="d-flex align-items-center justify-content-between" style="width: 40px;">
              <div class="star-icon" @click.stop="toggleFavorite(result)">
                <icon-base
                  :iconStroke="
                    favoriteDatasets.some((favorite) => favorite.id === result.id)
                      ? 'var(--flame)'
                      : 'rgb(158, 167, 172)'
                  "
                  :iconColor="favoriteDatasets.some((favorite) => favorite.id === result.id) ? 'var(--flame)' : 'none'"
                  width="14"
                  height="14"
                >
                  <icon-star />
                </icon-base>
              </div>
              <i class="fa-light fa-chevron-right"></i>
            </div>
          </div>
          <div
            v-if="!searching && searched && $store.state.templateDataSearchResults.length == 0 && filter.length"
            class="no-results text-muted"
          >
            {{ $t("tp-data-popover.no-result1") }} '{{ filter }}' {{ $t("tp-data-popover.no-result2") }}
          </div>
        </div>
        <div class="actions">
          <button @click="onSave" :disabled="loading || !hasChanges" class="btn btn-primary">
            {{ $t("tp-data-popover.save-btn") }}
          </button>
          <!-- <button  @click.stop.prevent="onClose()" class="btn btn-secondary">{{$t('tp-data-popover.cancel-btn')}}</button> -->
        </div>
      </div>
      <div class="popover-step">
        <div class="form-group" v-if="selectedDataset && selectedDataset.hasVariations == true">
          <label v-show="!selectedVariation" for="variationSelect" class="variation-label">{{
            $store.state.template.metadata.contentType.name == "DanDomainClassic" ? "Variants" : "Variations"
          }}</label>
          <!-- <i class="fa-light fa-chevron-down"></i> -->
          <select
            :disabled="loading"
            name="variationSelect"
            class="form-control selector"
            v-model="selectedVariation"
            @change="onSelectResult(selectedVariation, true)"
          >
            <option :value="selectedDataset"
              >{{ selectedDataset.referenceName }} {{ $t("tp-data-popover.variation-main") }}</option
            >
            <option v-for="variation in selectedDataset.variations" :key="variation.id" :value="variation">{{
              variation.referenceName
            }}</option>
          </select>
        </div>

        <div v-if="variableGroups && !loading">
          <variable-selector
            class="variable-list"
            :class="{ shrink: selectedDataset && selectedDataset.hasVariations == true }"
            :variable-groups="variableGroups"
            :show-values="true"
            :focusInputField="false"
          />
        </div>
        <div v-if="loading" style="margin-top: 30px" class="text-center text-muted">
          <i class="fa-light fa-circle-notch fa-spin"></i>
        </div>
      </div>
    </div>
  </custom-popover>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import CustomPopover from "@/components/CustomPopover";
import VariableSelector from "@/components/VariableSelector";
import VariableHelpers from "@/assets/js/variableHelpers";
import VariableGroup from "@/assets/js/variableGroup";
import IconBase from "@/components/icons/IconBase";
import IconStar from "@/components/icons/IconStar";
import debounce from "lodash/debounce";
export default {
  name: "templateDataPopover",
  props: {
    lockTemplateDataSearch: Boolean,
    multiPreview: Boolean,
    singleItemToReplace: Number
  },
  data() {
    return {
      selectedVariation: null,
      selectedDatasetId: null,
      selectedDataset: null,
      filter: "",
      eraser: false,
      searching: false,
      searched: false,
      onFilterChangeDebounce: debounce((filter) => {
        if (filter.length) this.search(filter).then(() => (this.searching = false), () => (this.searching = false));
        else {
          this.$store.state.templateDataSearchResults = [];
          this.searching = false;
        }
      }, 500),
      variables: null,
      loading: false
    };
  },
  methods: {
    toggleFavorite(result) {
      this.$store.dispatch("toggleFavorites", result);
    },
    onSave() {
      if (!this.hasChanges && !this.multiPreview) return;
      this.$store.state.templateVariables = this.variables;
      this.$store.state.currentDatasetId = this.selectedDatasetId;
      this.$store
        .dispatch("getTemplatePreview", {
          template: this.$store.state.template,
          variables: this.$store.state.templateVariables,
          generateAIContent: false
        })
        .then((preview) => {
          if (this.multiPreview == true) {
            const mulitPreviewItem = {
              variables: this.$store.state.templateVariables,
              preview: preview,
              selectedDataset: this.selectedDataset,
              loading: false
            };
            if (this.singleItemToReplace !== null) {
              this.$store.state.templateMultiplePreview[this.singleItemToReplace] = mulitPreviewItem;
            } else {
              this.$store.state.templateMultiplePreview.push(mulitPreviewItem);
            }
          }
          // this.$store.state.templatePreview = preview;
          this.$store.commit("setTemplatePreview", preview);
          this.$store.commit("setSelectedDataset", {
            selectedDataset: this.selectedVariation ? this.selectedVariation : this.selectedDataset
          });
          this.onClose();
          this.$store.dispatch("getTemplatePreviewForSectionType", "ai")
        });
    },
    onClose() {
      this.$emit("close");
    },
    search() {
      console.log(this.$store.state.template);
      return this.$store
        .dispatch("searchVariables", {
          filter: this.filter,
          templateId: this.$store.state.template.metadata.id
        })
        .then((results) => {
          this.searched = true;
          this.$store.state.templateDataSearchResults = results;
          console.log(results.length);
        });
    },

    onEraseFilter(filter) {
      this.filter = "";
      filter = "";
      this.onFilterChange(filter);
      this.$refs.searchinput.focus();
    },
    onFilterChange(filter) {
      if (this.filter == "") {
        this.eraser = false;
      }
      if (this.filter != "") {
        this.eraser = true;
      }
      this.searching = true;
      this.onFilterChangeDebounce(filter);
    },
    onSelectResult(result, selectedIsVariation) {
      this.selectedVariation = null;
      this.variables = null;
      this.selectedDatasetId = result ? result.id : null;
      if (!selectedIsVariation) this.selectedDataset = result ? result : null;
      else this.selectedVariation = result ? result : null;
      this.loading = true;
      this.$store
        .dispatch("getVariables", {
          template: this.$store.state.template.metadata,
          id: result ? result.id : null
        })
        .then(
          (vars) => {
            this.variables = vars;
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    }
  },
  computed: {
    isDemo() {
      return this.$store.state.editorIsDemoVersion;
    },
    resultList() {
      if (this.isDemo) {
        return this.filter
          ? this.$store.state.templateDataSearchResults
          : this.favoriteDatasets.concat(
              this.$store.state.demoFavoriteList.filter((p) => !this.favoriteDatasets.map((p) => p.id).includes(p.id))
            );
      } else {
        return this.filter ? this.$store.state.templateDataSearchResults : this.favoriteDatasets;
      }
    },
    favoriteDatasets() {
      return this.$store.state.dataFavorites;
    },
    hasChanges() {
      return this.selectedDatasetId !== this.$store.state.currentDatasetId;
    },
    variableGroups() {
      if (!this.selectedDatasetId && !this.variables) return this.$store.getters.variableGroups;
      if (!this.variables) return null;
      let combinedVars = [
        ...(this.variables || []),
        ...(this.$store.state.template.extraVariables.map((v) => ({
          custom: true,
          type: "Bool",
          ...v
        })) || [])
      ].reduce((vars, v) => {
        vars[v.name] = v;
        return vars;
      }, {});
      return new VariableGroup(VariableHelpers.groupVariables(combinedVars));
    },
    searchPlaceholder() {
      if (
        this.$store.state.fixedConnectors
          .map((c) => c.value)
          .filter((c) => c !== "XmlFeed")
          .includes(this.$store.state.template.metadata.contentType.name)
      ) {
        return this.$t("tp-data-popover.product-search");
      } else {
        switch (this.$store.state.template.metadata.contentType.name) {
          case "SoccerMatch":
            return this.$t("tp-data-popover.soccer-search");
          case "CompanyResume":
            return this.$t("tp-data-popover.company-search");
          case "PersonResume":
            return this.$t("tp-data-popover.person-search");
          default:
            return this.$t("tp-data-popover.default-search");
        }
      }
    }
  },
  components: {
    CustomPopover,
    VariableSelector,
    CustomInput,
    IconBase,
    IconStar
  },
  mounted() {
    this.selectedDatasetId = this.$store.state.currentDatasetId;
    this.selectedDataset = this.$store.state.selectedDataset;
    this.variables = this.$store.state.templateVariables;
  }
};
</script>

<style lang="less">
.template-data-popover {
  line-height: 1.5;
  position: absolute;
  color: var(--charcoal);
  &.custom-popover {
    right: calc(50% - (600px / 2));
    left: unset;
    top: calc(50% - (400px / 2));
    &::before {
      display: none;
    }
    .close-button {
      display: none;
    }
  }
  .search-filter {
    position: relative;
    margin: 0 12px 12px 12px;
    .search-icon,
    .searching {
      position: absolute;
      right: 10px;
      bottom: 7px;
      width: 13px;
    }
    .searching {
      bottom: 12px;
    }

    .close-icon {
      position: absolute;
      right: 30px;
      bottom: 12px;
      width: 13px;
    }
  }
  .form-group {
    position: relative;
    margin: 2px 15px;
    label.variation-label {
      position: absolute;
      top: 4px;
      margin: 0;
      padding: 0 4px;
      // color: #DBDADA !important;
      font-weight: 400 !important;
      font-size: 14px !important;
      // text-transform: uppercase
    }
    select:disabled {
      opacity: 0.5;
    }
    .form-control.selector {
      cursor: pointer;
      padding: 4px !important;
    }
    & > svg {
      font-size: 12px;
      position: absolute;
      right: 8px;
      top: 10px;
      pointer-events: none;
    }
  }

  .result-list {
    max-height: calc(300px - 86px);
    overflow: auto;
    .result-item {
      position: relative;
      display: flex;
      align-items: center;
      padding: 5px 20px;
      cursor: pointer;
      span {
        flex-grow: 1;
      }
      svg {
        opacity: 0;
      }
      .star-icon svg {
        opacity: 1;
      }
      &:hover {
        background-color: rgba(219, 218, 218, 0.4);
        > div > img,
        svg {
          opacity: 1;
        }
      }

      &.is-selected {
        background-color: rgba(219, 218, 218);
        img,
        svg {
          opacity: 1;
        }
      }
      .star-icon {
        margin-top: 1px;
      }
    }

    .no-results {
      text-align: center;
      padding: 20px;
    }
    .fa-chevron-right {
      font-size: 12px;
    }
  }

  .data-selector {
    min-height: 342px;
    display: flex;
    flex-direction: column;
    position: relative;
    .actions {
      position: absolute;
      display: flex;
      gap: 12px;
      bottom: 12px;
      left: 12px;
      // align-self: flex-end;
    }
  }

  .variable-list {
    padding-top: 0;
    padding-bottom: 0;
    width: 300px;
    // min-height: 300px;
    .variable-list-wrapper {
      max-height: 250px;
      overflow: auto;
    }
  }
  div.variable-selector.variable-list.shrink {
    // min-height: calc(300px - 51px);
    .variable-list-wrapper {
      max-height: calc(260px - 51px);
    }
  }
  .popover-header {
    color: var(--charcoal);
    .left-side-header {
      display: flex;
      gap: 12px;
      align-items: center;
      h2 {
        margin: 0;
      }
    }
  }
}
</style>
